import { cva } from 'class-variance-authority';
import { ElementIntent } from '../../enums';
export const dropdownItemStyling = cva('hover:bg-gray-50/50 px-3 py-2 cursor-pointer focus:outline-none flex items-center gap-2', {
    variants: {
        intent: {
            [ElementIntent.Info]: 'text-gray-700',
            [ElementIntent.Danger]: 'text-red-500',
        },
        disabled: {
            true: 'cursor-not-allowed opacity-80 hover:bg-transparent',
            false: 'cursor-pointer',
        },
    },
    defaultVariants: {
        intent: ElementIntent.Info,
        disabled: false,
    },
});
